export const assignmentType = 'assignment';
